import React, { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";

const AlertUI = ({ type = "primary", text = "", width = '500px' }) => {
  const [show, setShow] = useState(true);

  const getIcon = () => {
    if (type === "success") return <i className="ri-checkbox-circle-fill fs-5"></i>;
    if (type === "error") return <i className="ri-close-circle-fill fs-5"></i>;
    if (type === "warning") return <i className="ri-error-warning-fill fs-5"></i>;
    return <i className="ri-information-fill fs-5"></i>;
  };

  const getVariant = () => {
    if (type === "success") return 'success';
    if (type === "error") return 'danger';
    if (type === "warning") return 'warning';
    return 'warning';
  };


  // Auto close after 4 sec
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className={`d-flex justify-content-center align-items-center gap-2 mb-0`}>
      <Alert variant={getVariant()} dismissible onClose={() => setShow(false)} style={{ width: width, overflowWrap: "break-word", wordBreak: "break-word",display:'flex',alignItems:'center' }}>
        {getIcon()} {text}
      </Alert>
    </div>
  );
};

//Example for use Alert
// <Alert type={'success'} text={'Login successful!'} />
// <Alert type={'error'} text={'Something went wrong!'} />
// <Alert type={'warning'} text={'Check your input!'} /> 

export default AlertUI;